/* TAJA · Send to several people (ELYSIAN, Oct 18, 2026)
   The bag is the list: every item records who it's for.
   - People live on the bag (cart attribute _gift_people), so they survive a refresh.
   - Each item carries _gift_to (person id) and "Gift for" (their name).
   - Product pages: "Sending to more than one person?" opens "Who's it for?".
     Same for everyone: one Add to bag adds one per person.
     Different for each person: the page runs once per person ("Designing for Mom, 1 of 3").
   - Bag: the grouping, "For" pickers, notes, gift wrap per box and "Review and pay" are rendered by the theme
     (snippets/dl-gift-bag, dl-gift-for, dl-gift-scan, dl-gift-shipnote) from cart attribute _gift_index, so the
     drawer and cart page never jump after they load. This file handles the dialogs and the bag actions.
   - Review and pay (/apps/gift-list/review, served by the Gift List app) uses the same dialogs through
     window.dlGift. After the invoice is paid, the next page load empties the paid items from the bag.
   Nothing changes for a shopper who never opens it. */
(() => {
  if (window.__dlGiftTo) return;
  window.__dlGiftTo = true;

  const cfgEl = document.getElementById('dl-gift-to-config');
  let CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  const PRODUCT = CFG.product || null; /* { handle, title, ships } on product pages */
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const STATES = [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['PR','Puerto Rico'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming']];
  const TO = '_gift_to', FOR = 'Gift for';
  const dbg = (...a) => { try { if (window.__dlGtDebug || localStorage.getItem('dl-gt-debug')) console.log('[dl-gt]', ...a); } catch (e) {} };

  /* ---------- helpers ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (c) => '$' + ((c % 100 === 0) ? (c / 100).toLocaleString('en-US') : (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  const nameOf = (p) => [p.first, p.last].filter(Boolean).join(' ').trim();
  const placeOf = (p) => [p.city, p.province].filter(Boolean).join(', ');
  const uid = () => 'p' + Math.random().toString(36).slice(2, 8);
  const baseFetch = window.fetch.bind(window);
  const j = (method, url, body) => baseFetch(ROOT.replace(/\/$/, '') + url, {
    method, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined,
  }).then((r) => r.json().then((x) => { if (!r.ok) throw x; return x; }));

  /* ---------- cart + people ---------- */
  let cart = null;
  const getCart = () => j('get', '/cart.js').then((c) => { cart = c; return c; });
  const people = () => {
    try { const v = cart && cart.attributes && cart.attributes._gift_people; const a = v ? JSON.parse(v) : []; return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  };
  const personById = (id) => people().find((p) => p.id === id) || null;
  const meNote = () => (cart && cart.attributes && cart.attributes._gift_me_note) || '';
  /* _gift_index is what the theme reads (Liquid can split text, not JSON): "id|Name|City, ST|note|address" rows joined by "~". */
  const clean = (v) => String(v == null ? '' : v).replace(/[|~\r\n]+/g, ' ').trim();
  const addressOf = (p) => [p.address1, p.address2, [p.city, [p.province, p.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')].filter(Boolean).join(', ');
  const indexOf = (list, mine) => {
    const rows = list.map((p) => [p.id, nameOf(p), placeOf(p), p.note, addressOf(p)].map(clean).join('|'));
    if (mine) rows.push(['me', '', '', mine, ''].map(clean).join('|'));
    return list.length ? rows.join('~') : '';
  };
  const savePeople = (list, mine) => {
    const note = mine == null ? meNote() : mine;
    return j('post', '/cart/update.js', { attributes: {
      _gift_people: list.length ? JSON.stringify(list) : '',
      _gift_index: indexOf(list, note),
      _gift_me_note: list.length ? note : '',
    } }).then((c) => { cart = c; return c; });
  };

  /* Move one bag line to a person (null = the shopper). Keeps every other property, including
     Key Product Options' hidden ones (its paid add-ons ride on the line). */
  const assignLine = (line, personId) => {
    const props = Object.assign({}, line.properties || {});
    delete props[TO]; delete props[FOR];
    const p = personId ? personById(personId) : null;
    if (p) { props[TO] = p.id; props[FOR] = nameOf(p); }
    Object.keys(props).forEach((k) => { if (props[k] == null) delete props[k]; });
    return j('post', '/cart/change.js', { id: line.key, quantity: line.quantity, properties: props }).then((c) => { cart = c; return c; });
  };
  /* Redraw the bag from the theme (no page reload): the cart page swaps its item list and summary in place,
     the drawer uses the theme's own refresh. */
  const onCartPage = () => !!document.getElementById('main-cart-items');
  const refreshCartPage = () => {
    const items = document.getElementById('main-cart-items');
    const foot = document.getElementById('main-cart-footer');
    const ids = [items && items.dataset.id, foot && foot.dataset.id].filter(Boolean);
    if (!ids.length) { location.reload(); return Promise.resolve(); }
    /* No "Accept: application/json" here: on /cart that header returns the cart's JSON instead of the sections. */
    return baseFetch(location.pathname + '?sections=' + ids.join(',') + '&_=' + Date.now(), { cache: 'no-store' })
      .then((r) => r.json())
      .then((secs) => {
        [[items, 'main-cart-items'], [foot, 'main-cart-footer']].forEach(([el, domId]) => {
          if (!el || !secs[el.dataset.id]) return;
          const doc = new DOMParser().parseFromString(secs[el.dataset.id], 'text/html');
          const src = doc.getElementById(domId);
          if (src) el.innerHTML = src.innerHTML;
        });
      })
      .catch(() => location.reload());
  };
  const setBusy = (on) => document.querySelectorAll('cart-drawer, #main-cart-items').forEach((el) => el.classList.toggle('dl-gt-busy', !!on));
  const changed = () => { try { document.dispatchEvent(new CustomEvent('dl:bag-changed')); } catch (e) {} };
  const refreshBag = () => {
    setBusy(false);
    changed();
    if (onCartPage()) return refreshCartPage();
    const cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function' && typeof cd.getSectionsToRender === 'function') {
      const ids = cd.getSectionsToRender().map((x) => x.id);
      return baseFetch(ROOT + '?sections=' + ids.join(',') + '&_=' + Date.now(), { cache: 'no-store' })
        .then((r) => r.json())
        .then((secs) => { cd.renderContents({ sections: secs }, false); })
        .catch(() => { if (typeof cd.refreshCartDrawer === 'function') cd.refreshCartDrawer(); });
    }
    if (cd && typeof cd.refreshCartDrawer === 'function') cd.refreshCartDrawer();
    else document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    return Promise.resolve();
  };

  /* ---------- the "Add a person" / "Who's it for?" dialog ---------- */
  let dlg = null;
  const ensureDialog = () => {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'dl-gt-dlg';
    dlg.setAttribute('aria-labelledby', 'dl-gt-title');
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', () => { document.documentElement.classList.remove('dl-gt-lock'); });
    return dlg;
  };
  const openDialog = (html, onReady) => {
    const d = ensureDialog();
    d.innerHTML = '<div class="dl-gt-dlg__in">' + html + '</div>';
    d.querySelectorAll('[data-gt-close]').forEach((b) => b.addEventListener('click', () => d.close()));
    if (!d.open) { d.showModal(); document.documentElement.classList.add('dl-gt-lock'); }
    if (onReady) onReady(d);
    const first = d.querySelector('[autofocus]') || d.querySelector('input, select, button');
    if (first) setTimeout(() => first.focus(), 30);
    return d;
  };

  const personForm = (p) => {
    p = p || {};
    const st = STATES.map(([c, n]) => '<option value="' + c + '"' + (p.province === c ? ' selected' : '') + '>' + n + '</option>').join('');
    return '<form class="dl-gt-form" novalidate>' +
      '<div class="dl-gt-row2"><label class="dl-gt-f"><span>First name</span><input name="first" autocomplete="off" value="' + esc(p.first) + '" required autofocus></label>' +
      '<label class="dl-gt-f"><span>Last name</span><input name="last" autocomplete="off" value="' + esc(p.last) + '" required></label></div>' +
      '<label class="dl-gt-f"><span>Company <em>(optional)</em></span><input name="company" autocomplete="off" value="' + esc(p.company) + '"></label>' +
      '<label class="dl-gt-f"><span>Street address</span><input name="address1" autocomplete="off" value="' + esc(p.address1) + '" required></label>' +
      '<label class="dl-gt-f"><span>Apt, suite <em>(optional)</em></span><input name="address2" autocomplete="off" value="' + esc(p.address2) + '"></label>' +
      '<div class="dl-gt-row3"><label class="dl-gt-f"><span>City</span><input name="city" autocomplete="off" value="' + esc(p.city) + '" required></label>' +
      '<label class="dl-gt-f"><span>State</span><select name="province" required><option value="">Choose</option>' + st + '</select></label>' +
      '<label class="dl-gt-f"><span>ZIP</span><input name="zip" inputmode="numeric" autocomplete="off" value="' + esc(p.zip) + '" required></label></div>' +
      '<label class="dl-gt-f"><span>Phone <em>(optional, for the carrier)</em></span><input name="phone" type="tel" autocomplete="off" value="' + esc(p.phone) + '"></label>' +
      '<label class="dl-gt-f"><span>Gift note <em>(optional, one card in their box)</em></span><textarea name="note" rows="2" maxlength="200" placeholder="To, from and your message">' + esc(p.note) + '</textarea></label>' +
      '<p class="dl-gt-err" role="alert" hidden></p>' +
      '</form>';
  };
  const readPerson = (form, base) => {
    const f = new FormData(form); const g = (k) => String(f.get(k) || '').trim();
    const p = Object.assign({}, base || {}, {
      first: g('first'), last: g('last'), company: g('company'), address1: g('address1'), address2: g('address2'),
      city: g('city'), province: g('province'), zip: g('zip'), phone: g('phone'), note: g('note').slice(0, 200), country: 'US',
    });
    if (!p.id) p.id = uid();
    const miss = [];
    if (!p.first || !p.last) miss.push('their full name');
    if (!p.address1 || !p.city) miss.push('the street address and city');
    if (!p.province) miss.push('the state');
    if (!/^\d{5}(-\d{4})?$/.test(p.zip)) miss.push('a 5-digit ZIP');
    return { p, err: miss.length ? 'Please add ' + miss.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.' : '' };
  };

  /* Add or edit a person. Resolves with the saved person, or null if closed. */
  const editPerson = (existing, opts) => new Promise((resolve) => {
    opts = opts || {};
    let done = false;
    const title = existing ? 'Edit ' + esc(nameOf(existing)) : 'Add a person';
    openDialog(
      '<div class="dl-gt-dlg__head"><p class="dl-up dl-stone">' + (opts.eyebrow || 'Ships to their address') + '</p>' +
      '<h2 class="dl-dsp" id="dl-gt-title">' + title + '</h2>' +
      '<button type="button" class="dl-gt-x" data-gt-close aria-label="Close">&times;</button></div>' +
      '<p class="dl-gt-lede">We ship to U.S. addresses. Their gift arrives in its own box.</p>' +
      personForm(existing) +
      '<div class="dl-gt-dlg__foot">' +
      (existing && opts.canRemove ? '<button type="button" class="dl-gt-link dl-gt-remove" data-gt-remove>Remove ' + esc(existing.first) + '</button>' : '<span></span>') +
      '<button type="button" class="dl-bt dl-gt-save" data-gt-save>' + (existing ? 'Save' : 'Add ' + (opts.saveLabel || 'person')) + '</button></div>',
      (d) => {
        const form = d.querySelector('form');
        const err = d.querySelector('.dl-gt-err');
        const save = d.querySelector('[data-gt-save]');
        const submit = () => {
          const { p, err: e } = readPerson(form, existing);
          if (e) { err.textContent = e; err.hidden = false; return; }
          save.disabled = true; save.textContent = 'Saving';
          const list = people().filter((x) => x.id !== p.id);
          const idx = existing ? people().findIndex((x) => x.id === p.id) : -1;
          if (idx >= 0) list.splice(idx, 0, p); else list.push(p);
          const renamed = existing && nameOf(existing) !== nameOf(p);
          savePeople(list)
            .then(() => renamed ? relabelLines(p) : null)
            .then(() => { done = true; d.close(); resolve(p); })
            .catch(() => { save.disabled = false; save.textContent = 'Save'; err.textContent = "We couldn't save that. Please try again."; err.hidden = false; });
        };
        form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
        save.addEventListener('click', submit);
        const rm = d.querySelector('[data-gt-remove]');
        if (rm) rm.addEventListener('click', () => {
          rm.disabled = true;
          const lines = (cart && cart.items || []).filter((l) => l.properties && l.properties[TO] === existing.id);
          lines.reduce((pr, l) => pr.then(() => getCart()).then(() => {
            const cur = cart.items.find((x) => x.properties && x.properties[TO] === existing.id && x.variant_id === l.variant_id);
            return cur ? assignLine(cur, null) : null;
          }), Promise.resolve())
            .then(() => savePeople(people().filter((x) => x.id !== existing.id)))
            .then(() => { done = true; d.close(); resolve(null); emitPeople(); });
        });
        d.addEventListener('close', () => { if (!done) resolve(null); }, { once: true });
      });
  });
  const relabelLines = (p) => {
    const mine = (cart && cart.items || []).filter((l) => l.properties && l.properties[TO] === p.id);
    return mine.reduce((pr) => pr.then(() => getCart()).then(() => {
      const cur = cart.items.find((x) => x.properties && x.properties[TO] === p.id && x.properties[FOR] !== nameOf(p));
      return cur ? assignLine(cur, p.id) : null;
    }), Promise.resolve());
  };
  const peopleListeners = new Set();
  const emitPeople = () => peopleListeners.forEach((f) => { try { f(); } catch (e) {} });

  /* =================================================================== */
  /* Product page                                                         */
  /* =================================================================== */
  const sel = { ids: [], mode: 'same', i: 0, done: 0 }; /* ids: person ids, 'me' for the shopper */
  let armed = null; /* { targets, until } while an Add to bag is in flight */
  const productName = () => { const h = document.querySelector('.dl-cz__title, .dl-pdp h1, main h1'); return (h && h.textContent.trim()) || (PRODUCT && PRODUCT.title) || 'This gift'; };
  const active = () => sel.ids.length > 0 && !(sel.ids.length === 1 && sel.ids[0] === 'me');
  const labelFor = (id) => id === 'me' ? 'You' : (personById(id) ? nameOf(personById(id)) : 'Someone');
  const isDesignTool = () => !!document.querySelector('[data-dl-cz]');
  /* Personalized = the design tool, or Key Product Options fields a shopper fills in (names, messages, letters, photos). */
  const isPersonal = () => isDesignTool() || !!document.querySelector('#key_options_block .key_option input[type=text], #key_options_block .key_option textarea, #key_options_block .key_option input[type=file], #key_options_block .key_option select');

  const mountProduct = () => {
    if (!PRODUCT || PRODUCT.ships === false) return;
    const cz = document.querySelector('[data-dl-cz]');
    let host = null;
    if (cz) {
      const list = cz.querySelector('.dl-cz__list');
      host = document.createElement('div');
      if (list) list.replaceWith(host); else (cz.querySelector('[data-cz-ctawrap]') || cz).after(host);
    } else {
      const buy = document.querySelector('.dl-pdp__buybox');
      const pf = document.querySelector('product-form');
      host = document.createElement('div');
      if (buy) buy.appendChild(host); else if (pf) pf.after(host); else return;
    }
    host.className = 'dl-gt';
    host.setAttribute('data-dl-gt', '');
    host.setAttribute('aria-live', 'polite');

    let draw = () => {
      if (!active()) {
        const n = people().length;
        host.innerHTML = sel.done
          ? '<p class="dl-gt__ok">Added for everyone. Check each person in your bag.</p><button type="button" class="dl-gt__link" data-gt-open>Send this to more people</button>'
          : '<button type="button" class="dl-gt__link" data-gt-open>Sending to more than one person?</button>' +
            '<p class="dl-gt__sub">Choose who it\'s for, and each gift ships to its own address in one order.' + (n ? '' : '') + '</p>';
      } else if (sel.mode === 'each' && sel.ids.length > 1) {
        const id = sel.ids[sel.i];
        host.innerHTML = '<div class="dl-gt__turn"><p class="dl-up dl-stone">Different for each person · ' + (sel.i + 1) + ' of ' + sel.ids.length + '</p>' +
          '<p class="dl-gt__who">' + (isDesignTool() ? 'Designing' : 'Personalizing') + (id === 'me' ? ' <b>yours</b>' : ' for <b>' + esc(labelFor(id)) + '</b>') + '</p>' +
          '<p class="dl-gt__sub">Set ' + (id === 'me' ? 'your' : esc(personById(id) ? personById(id).first : 'their') + '\'s') + ' personalization above, then add to bag. Your other choices stay as they are.</p>' +
          '<div class="dl-gt__acts"><button type="button" class="dl-gt__link" data-gt-skip>Skip ' + (id === 'me' ? 'mine' : esc(personById(id) ? personById(id).first : 'this person')) + '</button>' +
          '<button type="button" class="dl-gt__link" data-gt-open>Change people</button><button type="button" class="dl-gt__link" data-gt-stop>Stop</button></div></div>';
      } else {
        const names = sel.ids.map(labelFor);
        host.innerHTML = '<div class="dl-gt__sum"><p class="dl-up dl-stone">' + (sel.ids.length > 1 ? 'One for each · ' + sel.ids.length + ' gifts' : 'Gift for') + '</p>' +
          '<p class="dl-gt__who">' + esc(names.join(', ')) + '</p>' +
          '<p class="dl-gt__sub">' + (sel.ids.length > 1 ? 'Add to bag adds one for each person, all the same. Each ships to its own address.' : 'Add to bag puts this in ' + esc(names[0]) + '\'s box.') + '</p>' +
          '<div class="dl-gt__acts"><button type="button" class="dl-gt__link" data-gt-open>Change</button><button type="button" class="dl-gt__link" data-gt-stop>Just for me</button></div></div>';
      }
      host.querySelectorAll('[data-gt-open]').forEach((b) => b.addEventListener('click', () => { sel.done = 0; openChooser(); }));
      host.querySelectorAll('[data-gt-stop]').forEach((b) => b.addEventListener('click', () => { sel.ids = []; sel.i = 0; sel.done = 0; draw(); }));
      host.querySelectorAll('[data-gt-skip]').forEach((b) => b.addEventListener('click', () => advance()));
    };
    const advance = () => {
      sel.i += 1;
      if (sel.i >= sel.ids.length) { sel.ids = []; sel.i = 0; sel.done = 1; }
      draw();
    };

    const openChooser = (pre) => {
      const list = people();
      const chosen = new Set(pre || sel.ids);
      const row = (id, title, sub) => '<label class="dl-gt-pick"><input type="checkbox" value="' + esc(id) + '"' + (chosen.has(id) ? ' checked' : '') + '>' +
        '<span class="dl-gt-pick__t"><b>' + esc(title) + '</b><span>' + esc(sub) + '</span></span>' +
        (id !== 'me' ? '<button type="button" class="dl-gt-link" data-gt-edit="' + esc(id) + '">Edit</button>' : '') + '</label>';
      openDialog(
        '<div class="dl-gt-dlg__head"><p class="dl-up dl-stone">' + esc(productName()) + '</p>' +
        '<h2 class="dl-dsp" id="dl-gt-title">Who\'s it for?</h2>' +
        '<button type="button" class="dl-gt-x" data-gt-close aria-label="Close">&times;</button></div>' +
        '<p class="dl-gt-lede">Tick everyone who gets one. Each gift ships to its own address, and you pay once.</p>' +
        '<div class="dl-gt-picks">' + row('me', 'Me', 'Ships to the address you give at checkout') +
        list.map((p) => row(p.id, nameOf(p), [p.company, placeOf(p)].filter(Boolean).join(' · '))).join('') + '</div>' +
        '<button type="button" class="dl-gt-add" data-gt-new>+ Add a person</button>' +
        '<fieldset class="dl-gt-mode" hidden><legend class="dl-up dl-stone">Personalizing</legend>' +
        '<label class="dl-gt-radio"><input type="radio" name="dl-gt-mode" value="same"' + (sel.mode !== 'each' ? ' checked' : '') + '><span><b>The same for everyone</b><span>One Add to bag adds one for each person.</span></span></label>' +
        '<label class="dl-gt-radio"><input type="radio" name="dl-gt-mode" value="each"' + (sel.mode === 'each' ? ' checked' : '') + '><span><b>Different for each person</b><span>Make each one in turn: change the personalization, then add to bag.</span></span></label></fieldset>' +
        '<p class="dl-gt-err" role="alert" hidden></p>' +
        '<div class="dl-gt-dlg__foot"><span class="dl-gt-count"></span><button type="button" class="dl-bt" data-gt-done>Done</button></div>',
        (d) => {
          const boxes = () => [...d.querySelectorAll('.dl-gt-picks input[type=checkbox]')];
          const picked = () => boxes().filter((b) => b.checked).map((b) => b.value);
          const sync = () => {
            const ids = picked();
            d.querySelector('.dl-gt-mode').hidden = ids.length < 2 || !isPersonal();
            const n = ids.length;
            d.querySelector('.dl-gt-count').textContent = n > 1 ? n + ' gifts' : (n === 1 ? '1 gift' : '');
          };
          boxes().forEach((b) => b.addEventListener('change', sync));
          sync();
          d.querySelectorAll('[data-gt-edit]').forEach((b) => b.addEventListener('click', (e) => {
            e.preventDefault();
            const keep = picked();
            editPerson(personById(b.dataset.gtEdit), { canRemove: true }).then(() => { openChooser(keep.filter((id) => id === 'me' || personById(id))); });
          }));
          d.querySelector('[data-gt-new]').addEventListener('click', () => {
            const keep = picked();
            const m = d.querySelector('input[name=dl-gt-mode]:checked'); if (m) sel.mode = m.value;
            editPerson(null, { eyebrow: 'Who\'s it for?' }).then((p) => { openChooser(p ? keep.concat(p.id) : keep); });
          });
          d.querySelector('[data-gt-done]').addEventListener('click', () => {
            const ids = picked();
            if (!ids.length) { const er = d.querySelector('.dl-gt-err'); er.textContent = 'Choose at least one person.'; er.hidden = false; return; }
            const m = d.querySelector('input[name=dl-gt-mode]:checked');
            sel.ids = ids; sel.mode = ids.length > 1 && m && isPersonal() ? m.value : 'same'; sel.i = 0; sel.done = 0;
            d.close(); draw();
            const atc = document.querySelector('[data-dl-atc], [data-cz-ctawrap] button');
            if (atc && window.matchMedia('(max-width: 989px)').matches) host.scrollIntoView({ block: 'center', behavior: 'smooth' });
          });
        });
    };

    /* Arm on Add to bag: the next add-to-bag requests go to the chosen people. */
    document.addEventListener('click', (e) => {
      const b = e.target.closest('button, a[role=button], input[type=submit]');
      if (!b || b.closest('cart-drawer, .dl-gt-dlg, [data-dl-addons], .dl-gt')) return;
      const isAtc = b.matches('[data-dl-atc], [data-dl-baratc], [name=add], .cz-cta') || /add( \d+)? to (bag|cart)/i.test(b.textContent || '');
      if (!isAtc) return;
      if (!active()) { armed = null; return; }
      dbg('armed', b.className, sel.ids);
      const targets = sel.mode === 'each' && sel.ids.length > 1 ? [sel.ids[sel.i]] : sel.ids.slice();
      armed = { targets, until: Date.now() + 60000, each: sel.mode === 'each' && sel.ids.length > 1, advanced: false, base: cart ? snap(cart) : null };
      if (!cart) { const a = armed; getCart().then((c) => { if (!a.base) a.base = snap(c); }); }
    }, true);

    window.__dlGtAfterAdd = () => {
      if (!armed) return;
      armed.until = Math.min(armed.until, Date.now() + 10000); /* extras ("Finish the gift") follow within seconds */
      if (armed.each && !armed.advanced) { armed.advanced = true; advance(); }
      else if (!armed.each && !armed.advanced) { armed.advanced = true; sel.ids = []; sel.i = 0; sel.done = 1; draw(); }
    };
    /* The Add to bag label says what will happen: "Add 3 to bag · $177" or "Add to bag for Ann · $59". */
    /* Each unit is a label element plus, on the design tool, its separate price element. */
    const units = () => {
      const out = [];
      document.querySelectorAll('[data-dl-atc-label], [data-dl-barlabel]').forEach((el) => out.push({ label: el, price: null }));
      document.querySelectorAll('[data-cz-ctawrap] button').forEach((btn) => {
        const spans = [...btn.querySelectorAll(':scope > span')];
        const label = spans.find((x) => !/^\$/.test(x.textContent.trim()));
        const price = spans.find((x) => /^\$/.test(x.textContent.trim()));
        if (label) out.push({ label, price: price || null });
      });
      return out;
    };
    let relabeling = false;
    const swap = (el, fn) => {
      const cur = el.textContent;
      const base = el.dataset.gtBase && cur === el.dataset.gtOut ? el.dataset.gtBase : cur;
      el.dataset.gtBase = base;
      const out = fn(base);
      el.dataset.gtOut = out;
      if (cur !== out) el.textContent = out;
    };
    const times = (txt, n) => txt.replace(/\$([\d,]+(?:\.\d{2})?)/, (m, v) => money(Math.round(parseFloat(v.replace(/,/g, '')) * 100) * n));
    const relabel = () => {
      if (relabeling) return; relabeling = true;
      const each = sel.mode === 'each' && sel.ids.length > 1;
      const n = active() && !each ? sel.ids.length : 1;
      const who = active() ? (each ? sel.ids[sel.i] : (sel.ids.length === 1 ? sel.ids[0] : null)) : null;
      const first = who && who !== 'me' && personById(who) ? personById(who).first : (who === 'me' ? 'you' : '');
      units().forEach(({ label, price }) => {
        let isAdd = false;
        swap(label, (base) => {
          if (!active() || !/add to bag/i.test(base)) return base;
          isAdd = true;
          let out = base.replace(/add to bag/i, (m) => {
            const t = n > 1 ? 'Add ' + n + ' to bag' : (first ? 'Add to bag for ' + first : m);
            return m === m.toUpperCase() ? t.toUpperCase() : t;
          });
          return n > 1 ? times(out, n) : out;
        });
        if (price) swap(price, (base) => (isAdd && n > 1 ? base + ' each' : base));
      });
      relabeling = false;
    };
    const lmo = new MutationObserver(() => { if (!relabeling) relabel(); });
    const watchLabels = () => {
      const zone = document.querySelector('[data-dl-cz]') || document.querySelector('.dl-pdp') || document.querySelector('main') || document.body;
      lmo.observe(zone, { childList: true, subtree: true, characterData: true });
    };
    watchLabels();
    peopleListeners.add(relabel);
    const draw0 = draw;
    draw = function () { draw0(); relabel(); };

    window.__dlGtBusy = (on) => {
      host.classList.toggle('is-busy', !!on);
      let m = host.querySelector('.dl-gt__busy');
      if (on && !m) { m = document.createElement('p'); m.className = 'dl-gt__busy'; m.textContent = 'Adding one for each person…'; host.prepend(m); }
      if (!on && m) m.remove();
    };
    peopleListeners.add(draw);
    draw();
  };

  /* After an Add to bag while people are chosen, the new items are moved to the first person and
     copied for everyone else. This works with every add path on the site (Key Product Options, the
     design tool, Finish the gift) because it reads the bag after the add instead of the request.
     Key Product Options' paid add-ons ride on the line's own properties, so the copies keep them. */
  const snap = (c) => new Map(((c && c.items) || []).map((l) => [l.key, l.quantity]));
  const addLine = (variantId, qty, props) => j('post', '/cart/add.js', { items: [{ id: variantId, quantity: qty, properties: props }] });
  const tagged = (props, id) => {
    const o = Object.assign({}, props || {});
    delete o[TO]; delete o[FOR];
    Object.keys(o).forEach((k) => { if (o[k] == null) delete o[k]; });
    const p = id && id !== 'me' ? personById(id) : null;
    if (p) { o[TO] = p.id; o[FOR] = nameOf(p); }
    return o;
  };
  let queue = Promise.resolve();
  const onAdded = (url) => {
    dbg('added', url, !!armed, armed && armed.targets);
    if (!armed || Date.now() > armed.until) return;
    const job = armed;
    queue = queue.then(() => new Promise((r) => setTimeout(r, 250))).then(() => getCart()).then((c) => {
      const base = job.base || new Map();
      const fresh = (c.items || []).filter((l) => !(l.properties && l.properties[TO]) && (!base.has(l.key) || l.quantity > base.get(l.key)))
        .map((l) => ({ l, add: l.quantity - (base.get(l.key) || 0) }));
      dbg('fresh', fresh.map((f) => f.l.title + ' +' + f.add));
      const isMain = !/[?&]dl=extras/.test(String(url));
      const after = () => { if (isMain) setTimeout(() => window.__dlGtAfterAdd && window.__dlGtAfterAdd(), 0); };
      if (!fresh.length) { after(); return null; }
      if (window.__dlGtBusy) window.__dlGtBusy(true);
      setBusy(true);
      const mine = new Set(); /* lines this job accounted for (a later job must not take them again) */
      const keep = (res) => { ((res && res.items) || []).forEach((it) => mine.add(it.key)); return res; };
      return fresh.reduce((pr, f) => pr.then(() => {
        const perDesign = !!(f.l.properties && f.l.properties.For); /* the design tool's mock-up: one per design */
        const targets = perDesign ? job.targets.slice(0, 1) : job.targets;
        const first = targets[0];
        let step = Promise.resolve();
        if (first && first !== 'me') {
          step = f.add < f.l.quantity
            ? j('post', '/cart/change.js', { id: f.l.key, quantity: f.l.quantity - f.add }).then(() => addLine(f.l.variant_id, f.add, tagged(f.l.properties, first)))
            : j('post', '/cart/change.js', { id: f.l.key, quantity: f.l.quantity, properties: tagged(f.l.properties, first) });
        } else mine.add(f.l.key);
        return targets.slice(1).reduce((p2, t) => p2.then(() => addLine(f.l.variant_id, f.add, tagged(f.l.properties, t)).then(keep)), step);
      }), Promise.resolve()).then(() => getCart()).then((c2) => {
        const next = new Map();
        (c2.items || []).forEach((l) => {
          if ((l.properties && l.properties[TO]) || mine.has(l.key)) next.set(l.key, l.quantity);
          else if (base.has(l.key)) next.set(l.key, Math.min(l.quantity, base.get(l.key)));
        });
        job.base = next;
        refreshBag();
        after();
      });
    }).catch(() => { refreshBag(); }).finally(() => { if (window.__dlGtBusy) window.__dlGtBusy(false); });
  };
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((list) => {
        list.getEntries().forEach((en) => {
          if (en.initiatorType === 'navigation' || !/\/cart\/add(\.js)?(\?|$)/.test(en.name)) return;
          if (en.responseStatus && en.responseStatus >= 400) return;
          onAdded(en.name);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  /* =================================================================== */
  /* Bag (drawer and cart page): the theme renders the groups; these are the actions                 */
  /* =================================================================== */
  const lineByKey = (key, n) => (cart && cart.items || []).find((l) => l.key === key) || (cart && cart.items[n - 1]) || null;

  /* "For" picker */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('.dl-gt-for__sel');
    if (!s) return;
    e.stopPropagation();
    const box = s.closest('[data-gt-line]');
    const n = Number(box.dataset.gtLine), key = box.dataset.gtKey;
    const go = (id) => {
      s.disabled = true; setBusy(true);
      getCart().then(() => { const line = lineByKey(key, n); return line ? assignLine(line, id === 'me' ? null : id) : null; })
        .then(() => refreshBag()).catch(() => { s.disabled = false; setBusy(false); });
    };
    if (s.value === '__new') {
      const prev = (lineByKey(key, n) || {}).properties || {};
      s.value = prev[TO] || 'me';
      editPerson(null, { eyebrow: 'Who\'s this for?' }).then((p) => { if (p) go(p.id); });
    } else go(s.value);
  }, true);

  const noteDialog = (id) => new Promise((resolve) => {
    const p = id === 'me' ? null : personById(id);
    if (id !== 'me' && !p) { resolve(false); return; }
    let saved = false;
    openDialog('<div class="dl-gt-dlg__head"><p class="dl-up dl-stone">One card in ' + (p ? esc(p.first) + '\'s' : 'your') + ' box</p>' +
      '<h2 class="dl-dsp" id="dl-gt-title">Gift note' + (p ? ' for ' + esc(p.first) : '') + '</h2>' +
      '<button type="button" class="dl-gt-x" data-gt-close aria-label="Close">&times;</button></div>' +
      '<label class="dl-gt-f"><span>Note <em>(up to 200 characters, handwritten at our studio)</em></span><textarea rows="4" maxlength="200" placeholder="To, from and your message">' + esc(p ? p.note : meNote()) + '</textarea></label>' +
      '<div class="dl-gt-dlg__foot"><span></span><button type="button" class="dl-bt" data-gt-savenote>Save note</button></div>', (d) => {
        d.querySelector('[data-gt-savenote]').addEventListener('click', (ev) => {
          const v = d.querySelector('textarea').value.trim().slice(0, 200);
          ev.target.disabled = true; ev.target.textContent = 'Saving';
          const save = p ? savePeople(people().map((x) => x.id === p.id ? Object.assign({}, x, { note: v }) : x)) : savePeople(people(), v);
          save.then(() => { saved = true; d.close(); refreshBag(); emitPeople(); });
        });
        d.addEventListener('close', () => resolve(saved), { once: true });
      });
  });

  document.addEventListener('click', (e) => {
    const start = e.target.closest('[data-gt-start]');
    if (start) {
      e.preventDefault();
      editPerson(null, { eyebrow: 'Who\'s it for?' }).then((p) => { if (p) refreshBag(); });
      return;
    }
    const ed = e.target.closest('[data-gt-editp]');
    if (ed) { e.preventDefault(); editPerson(personById(ed.dataset.gtEditp), { canRemove: true }).then(() => { refreshBag(); emitPeople(); }); return; }
    const nt = e.target.closest('[data-gt-note]');
    if (nt) { e.preventDefault(); noteDialog(nt.dataset.gtNote); return; }
    const wr = e.target.closest('[data-gt-wrap]');
    if (wr) {
      e.preventDefault();
      wr.disabled = true; wr.textContent = 'Adding gift wrap'; setBusy(true);
      const id = wr.dataset.gtWrap;
      addLine(Number(wr.dataset.variant), 1, tagged({}, id)).then(() => refreshBag()).catch(() => { wr.disabled = false; setBusy(false); });
    }
  }, true);

  /* Removing or changing a line on the cart page: the theme redraws the list; redraw the summary too
     so "Review and pay" and the box count stay right. */
  const watch = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        getCart().catch(() => {});
        changed();
        if (ev && ev.source === 'cart-items' && onCartPage()) refreshCartPage();
      });
    }
    document.addEventListener('l:product:added', () => getCart().catch(() => {}));
  };

  /* After Review and pay: the bag remembers the invoice (_gift_list) and the lines it covered
     (_gift_list_keys). Once that invoice is paid, those lines and the people leave the bag. */
  const LIST_STATUS = '/apps/gift-list/review/status?list=';
  const checkPaid = () => {
    const a = (cart && cart.attributes) || {};
    const id = a._gift_list;
    if (!id) return Promise.resolve(null);
    try {
      const k = 'dl-gt-paid-' + id, last = Number(sessionStorage.getItem(k) || 0);
      if (Date.now() - last < 15000) return Promise.resolve('open');
      sessionStorage.setItem(k, String(Date.now()));
    } catch (e) {}
    return baseFetch(LIST_STATUS + encodeURIComponent(id), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((s) => {
        if (s && s.state === 'paid') {
          const keys = String(a._gift_list_keys || '').split(',').filter(Boolean);
          const updates = {};
          keys.forEach((key) => { if ((cart.items || []).some((l) => l.key === key)) updates[key] = 0; });
          return j('post', '/cart/update.js', { updates, attributes: { _gift_list: '', _gift_list_keys: '', _gift_people: '', _gift_index: '', _gift_me_note: '' } })
            .then((c) => { cart = c; refreshBag(); return 'paid'; });
        }
        if (s && s.state === 'gone') {
          return j('post', '/cart/update.js', { attributes: { _gift_list: '', _gift_list_keys: '' } }).then((c) => { cart = c; return 'gone'; });
        }
        return 'open';
      })
      .catch(() => null);
  };

  window.dlGift = {
    ready: null,
    getCart: () => getCart(),
    editPerson: (id) => editPerson(personById(id), { canRemove: false }).then((p) => { refreshBag(); emitPeople(); return p; }),
    note: (id) => noteDialog(id),
  };
  const boot = () => {
    const got = getCart();
    window.dlGift.ready = got.then(() => checkPaid()).catch(() => null);
    got.then(() => { mountProduct(); watch(); }).catch(() => { mountProduct(); watch(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
